export const tr = {
    'confirm-delete': 'Negatif anahtar sözcük grubu listesini silmek istediğinize emin misiniz?',
    copy: 'Kopya',
    'create-success': '"{Name}" adlı negatif anahtar sözcük grupları listesi oluşturuldu',
    'delete-error': '"{Name}" adlı negatif anahtar sözcük grupları listesi silinirken hata oluştu',
    'delete-success': '"{Name}" adlı negatif anahtar sözcük grupları listesi silindi',
    'update-success': '"{Name}" adlı negatif anahtar sözcük grupları listesi düzenlendi'
};
